import Hero from '../components/home/Hero';
import AboutPreview from '../components/home/AboutPreview';
import ProductsOverview from '../components/home/ProductsOverview';
import WhyChooseUs from '../components/home/WhyChooseUs';
import TeamPreview from '../components/home/TeamPreview';
import Applications from '../components/home/Applications';
import Enquiry from '../components/home/Enquiry';

const Home = () => {
  return (
    <div className="flex flex-col">
      <Hero />
      <AboutPreview />
      <ProductsOverview />
      <WhyChooseUs />
      <TeamPreview />
      <Applications />
      <Enquiry />
    </div>
  );
};

export default Home;
